import ls from 'local-storage';
import axios from 'axios';
import { camelizeKeys, decamelizeKeys } from 'humps';
import AuthService from './AuthService';

class BaseService {

  static pageSize() {
    return 25;
  }

  static get(url) {

    return this.request('get', url);
  }

  static post(type, url, data) {

    let requestData = {
      data: {
        type,
        attributes: decamelizeKeys(data)
      }
    };

    return this.request('post', url, requestData);
  }

  static patch(type, url, data) {
    let requestData = {
      data: {
        id: data.id,
        type,
        attributes: decamelizeKeys(data)
      }
    };

    return this.request('patch', url, requestData);
  }

  static delete(url) {
    return this.request('delete', url);
  }

  /**
   * if the token expires in 5 min or less, refresh it.
   * this is easier than trying to queue up and then replay requests after the token has expired
   *
   * @param token
   * @returns {boolean}
   */
  static isTokenAlmostExpired (token) {
    let expires = new Date(0);
    expires.setUTCSeconds(token.created_at + token.expires_in - (5 * 60));

    if (expires === null) {
      return false;
    }

    // Token expired?
    if (!(expires.valueOf() > (new Date().valueOf()))) {
      AuthService.refreshToken();
    }
  }

  static request(requestType, url, data = null) {

    const user = ls.get('user');
    if (_.has(user, 'jwt')) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${user.jwt.access_token}`;

      let config = {};
      if (requestType === 'post' || requestType === 'patch') {
        config.headers = {
          'Content-Type': 'application/vnd.api+json'
        };
      }

      axios.interceptors.response.use((response) => {
        this.isTokenAlmostExpired(user.jwt);
        return response;
      }, (error) => {
        // Do something with response error
        if (error.response.status === 401) {
            AuthService.logout();
            window.location = '/';
        }
        return Promise.reject(error);
      });



      return axios[requestType](`${process.env.API_URL}/v1/${url}`, data, config);
    } else {
      return Promise.reject();
    }
  }



}

export default BaseService;